import { useSelector } from 'react-redux'

import { anonymousIdSelector } from 'selectors/segment'
import { eventService } from 'services/analytics/event_service'

export const useTrackingWithSegmentAnonymousId = () => {
  const anonymousId = useSelector(anonymousIdSelector)

  const track = (name, properties) => {
    if (!anonymousId) return

    eventService.dispatch({
      name,
      version: 1,
      entities: ['user'],
      dependencies: { user_uuid: anonymousId },
      properties
    })
  }

  return track
}
